import { render, staticRenderFns } from "./tableCommandes.vue?vue&type=template&id=6ecbcd16&"
import script from "./tableCommandes.vue?vue&type=script&lang=js&"
export * from "./tableCommandes.vue?vue&type=script&lang=js&"
import style0 from "./tableCommandes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports